import React, { useContext, useState } from 'react';
import './ScanLog.scss';
import { State, Action } from './Provider';
import { CloseButton, InfoView, StyleButton } from './Assets';
import { TabView } from './lib.r3/ui/ui-controls';
import NodeEdit from './lib.r3/ui/NodeEdit';
import store from './Store';


const headers = [
	'userid',
	'bundle-id',
	'bundle-name',
	'origin',
	'image',
	'start',
	'closed',
	'result',
	'state',
]

//============================================================================= ScanLog Hook
export default function ScanLog() {
	const action = useContext(Action);
	const state = useContext(State);

	const onClear = e => {
		let log = state.scanLog.filter(e => (e._state !== 'sent' && e._state !== 'sended'));
		action('scanLog', log);
	}

	// --- old release
	return (
		<div className='scan-log-view'>
			<div className='scan-log-header'>
				<div className='scan-log-title'>Scan-Log</div>
				<StyleButton secondary label='clear sent' width={120} height={36} margin={0} onClick={onClear} />
			</div>

			<div className='scan-log-item headline'>
				{headers.map((e, i) => <div key={i}>{e}</div>)}
			</div>

			<div className='scan-log'>
				{state.scanLog.map((e, i) => <LogItem key={i} data={e} />)}
			</div>

			<CloseButton onClick={e => action('open-scanLog', false)} />
		</div>
	)

	// --- new release
	return (
		<div className='scan-log'>
			<TabView onClose={e => action('open-scanLog', false)}>
				<ScanLogView label='Scan-Log' log={state.scanLog} onClear={onClear} />

				<InfoView label='Info' />

				<div label='Settings' className='settings-view'>
					{/* <SelectButton label='Clear Site Data' selected={true} onClick={e => Store.clearSiteData()} /> */}
					<NodeEdit setup={store.settings} />
				</div>
			</TabView>
		</div>
	)
}


// ============================================================================ ScanLogView
const ScanLogView = props => {

	return (
		<div className='scan-log-view'>
			{/* <div className='scan-log-header'>
				<StyleButton secondary label='clear sent' width={120} height={36} margin={0} onClick={props.onClear} />
			</div> */}

			<div className='scan-log-item headline'>
				{headers.map((e, i) => <div key={i}>{e}</div>)}
			</div>

			<div className='scan-log-list'>
				{props.log.map((e, i) => <LogItem key={i} data={e} />)}
			</div>
		</div>
	)
}


// ============================================================================ LogItem
const LogItem = props => {
	let scan = props.data;
	const [error, setError] = useState((!scan.image && !scan._image)? true : false)

	return (
		<div className='scan-log-item'>
			<div>{scan.user_id}</div>
			<div>{scan.bundle_id}</div>
			<div>{scan._name}</div>
			<div>{scan.origin}</div>
			<div className='thumb'>
				{!error &&
					<img src={scan.image || scan._image} alt='' onError={e => setError(true)} />
				}
			</div>
			<div>{scan.started_at}</div>
			<div>{'- ' + (typeof scan.closed_at === 'string' ? scan.closed_at.split(' ')[1] : scan.closed_at)}</div>
			{/* <div>{'- ' + scan.closed_at}</div> */}
			<div>{scan.result}</div>
			<div className={scan._state} >{scan._state}</div>
		</div>
	)
}
